export const apiData = {
  baseUrl: "https://around-the-us-backend.onrender.com",
};

 /* token from practicum "4c5ffc10-7ef8-4216-9730-733ca7b03273" */